import React from 'react';
import cx from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { ReactComponent as Close } from '../../assets/img/icons/common/Close.svg';
import './Modal.scss';

export const ModalPattern = ({
  id,
  title,
  TitleComponent,
  scrolled = false,
  size = null,
  modalBody,
  confirmText = null,
  cancelText = null,
  onClose,
  onCancel,
  onConfirm,
  confirmDisabled = false,
  customButtons = null,
  smallButtons = false,
  loading = false,
  className = '',
}) => {
  const disableConfirmBtn = loading || confirmDisabled;
  
  return (
    <div
      className={cx('modal fade show', { [className]: !!className })}
      id={id || 'ModalPassword'}
      tabIndex="-1"
      role="dialog"
      aria-labelledby="ModalPasswordLabel"
      aria-hidden="true"
    >
      <div
        role="document"
        className={`modal-dialog modal-dialog-centered modal__pattern ${
          size !== null ? `modal__pattern-${size}` : ''
        }`}
      >
        <div className="modal-content">
          <div className="modal-header">
            {TitleComponent ? TitleComponent : <h4 className="modal-title">{title}</h4>}
            <div className="modal-close__button" onClick={onClose ? onClose : onCancel}>
              <Close />
            </div>
          </div>
          <div className={cx('modal-body', { scrolled: scrolled })}>{modalBody}</div>
          <div className="modal-footer">
            <div className="modal-button__container">
              {customButtons !== null ? (
                customButtons
              ) : (
                <>
                  <button
                    type="button"
                    className={cx('modal-button modal-button__cancel', { cut: smallButtons })}
                    onClick={() => onCancel()}
                  >
                    {cancelText !== null ? cancelText : 'Cancel'}
                  </button>
                  <button
                    className={cx('modal-button modal-button__confirm', {
                      disabled: disableConfirmBtn,
                      cut: smallButtons,
                    })}
                    type="submit"
                    disabled={disableConfirmBtn}
                    onClick={() => onConfirm()}
                  >
                    {confirmText !== null ? confirmText : 'Save'}
  
                    {loading ? (
                      <div className="modal-button__confirm-loading">
                        <FontAwesomeIcon icon={faSpinner} size="lg" spin />
                      </div>
                    ) : null}
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
